const products = window.__PH_PRODUCTS__ || [];
const productMap = Object.fromEntries(products.map(p => [p.slug, p]));
const variantMap = {};
products.forEach(p => (p.variants || []).forEach(v => { variantMap[v.id] = p; }));
let cart = { items: [], item_count: 0, total_price: 0 };
const $ = (s, root=document) => root.querySelector(s);
const $$ = (s, root=document) => [...root.querySelectorAll(s)];
const money = n => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(n);
const esc = s => String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const ROUTES = window.__PH_ROUTES__ || { cartAdd:'/cart/add.js', cart:'/cart.js', cartChange:'/cart/change.js' };

const header = $('#siteHeader');
addEventListener('scroll',()=>header.classList.toggle('is-scrolled',scrollY>18),{passive:true});

const mobilePanel = $('#mobilePanel');
$('#menuButton').addEventListener('click',()=>{
  const open = mobilePanel.classList.toggle('open');
  $('#menuButton').textContent = open ? 'Close' : 'Menu';
});
$$('#mobilePanel a').forEach(a=>a.addEventListener('click',()=>{
  mobilePanel.classList.remove('open'); $('#menuButton').textContent='Menu';
}));

$$('.filter-button').forEach(btn=>btn.addEventListener('click',()=>{
  $$('.filter-button').forEach(b=>b.classList.remove('active'));
  btn.classList.add('active');
  const filter = btn.dataset.filter;
  $$('.product-card').forEach(card=>{
    card.classList.toggle('is-hidden', filter!=='All' && card.dataset.roast!==filter);
  });
}));

const scrim = $('#scrim');
const modal = $('#productModal');
const cartPanel = $('#cartPanel');
let lastFocused = null;
const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
function setInert(el,on){ if(on) el.setAttribute('inert',''); else el.removeAttribute('inert'); }
function lock(open){document.body.classList.toggle('locked',open);scrim.classList.toggle('open',open)}
function openOverlay(el){
  lastFocused = document.activeElement;
  el.classList.add('open'); setInert(el,false);
  const other = el === modal ? cartPanel : modal;
  other.classList.remove('open'); setInert(other,true);
  lock(true);
  const first = el.querySelector(FOCUSABLE);
  if(first) requestAnimationFrame(()=>first.focus());
}
function closeOverlays(){
  const wasOpen = modal.classList.contains('open') || cartPanel.classList.contains('open');
  modal.classList.remove('open'); cartPanel.classList.remove('open');
  setInert(modal,true); setInert(cartPanel,true);
  lock(false);
  if(wasOpen && lastFocused && document.contains(lastFocused)) lastFocused.focus();
  lastFocused = null;
}
// keep focus inside whichever overlay is open
function trapFocus(e){
  if(e.key !== 'Tab') return;
  const open = modal.classList.contains('open') ? modal : (cartPanel.classList.contains('open') ? cartPanel : null);
  if(!open) return;
  const items = [...open.querySelectorAll(FOCUSABLE)].filter(el=>el.offsetParent !== null);
  if(!items.length) return;
  const first = items[0], last = items[items.length-1];
  if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
  else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
}
addEventListener('keydown',trapFocus);
setInert(modal,true); setInert(cartPanel,true);
scrim.addEventListener('click',closeOverlays);
$('#modalClose').addEventListener('click',closeOverlays);
$('#cartClose').addEventListener('click',closeOverlays);
addEventListener('keydown',e=>{if(e.key==='Escape') closeOverlays()});

/* ---------- variant selection ---------- */
let activeProduct = null;
let selection = {};

function optionIndex(p,name){ return p.options.findIndex(o=>o.name===name) }
function matchVariant(p,sel){
  return (p.variants||[]).find(v => p.options.every((o,i)=> sel[o.name] === v.options[i])) || null;
}
// Is any variant available for this option value, given the other current choices?
function valueSelectable(p,name,value,sel){
  const idx = optionIndex(p,name);
  return (p.variants||[]).some(v =>
    v.available && v.options[idx] === value &&
    p.options.every((o,i)=> i>=idx || !sel[o.name] || sel[o.name] === v.options[i])
  );
}
// Does this option value exist on any variant at all?
function valueExists(p,name,value){
  const idx = optionIndex(p,name);
  return (p.variants||[]).some(v => v.options[idx] === value);
}
// Options cascade in order: only options chosen BEFORE this one constrain it.
// Country (first) always lists every country; roast (second) lists only the
// roasts that exist for the chosen country. Constraining Country by the selected
// roast hid Mexico Chiapas and Peru entirely, since neither has a Light roast
// and Light is what the modal opens on.
function valueCompatible(p,name,value,sel){
  const idx = optionIndex(p,name);
  return (p.variants||[]).some(v =>
    v.options[idx] === value &&
    p.options.every((o,i)=> i>=idx || !sel[o.name] || sel[o.name] === v.options[i])
  );
}
function defaultSelection(p){
  selection = {};
  if(!p.options || !p.options.length) return;
  const v = (p.variants||[]).find(x=>x.available) || (p.variants||[])[0];
  if(v) p.options.forEach((o,i)=>{ selection[o.name] = v.options[i] });
}
function chooseOption(p,name,value){
  selection[name] = value;
  // Sparse catalogs (42 variants, not every combination exists): if the new pair
  // has no variant, snap the other options to the first available one that does.
  if(!matchVariant(p,selection)){
    const idx = optionIndex(p,name);
    const fallback = (p.variants||[]).find(v=>v.available && v.options[idx]===value)
                  || (p.variants||[]).find(v=>v.options[idx]===value);
    if(fallback) p.options.forEach((o,i)=>{ selection[o.name] = fallback.options[i] });
  }
  renderOptions(p); renderOrigin(p); syncVariant(p);
}
/* Per-origin notes for a multi-origin product. The Single Origin listing keeps one
   <h4> section per country inside its Shopify description (heading, paragraph,
   flavor/acidity/body/finish bullets). The quick view reads those sections and shows
   the one for the chosen country, so the description stays the single place to edit. */
const ORIGIN_ALIASES = { 'Indonesia': ['sumatra','java','sulawesi'], 'Mexico Chiapas': ['chiapas','mexico'] };
function parseOriginSections(html){
  if(!html) return [];
  const doc = new DOMParser().parseFromString(html,'text/html');
  const out = []; let cur = null;
  [...doc.body.children].forEach(el=>{
    if(/^H[2-4]$/.test(el.tagName)){
      const h = el.cloneNode(true);
      h.querySelectorAll('span').forEach(x=>x.remove());   // "SOLD OUT" markers; availability comes from variants
      cur = { heading: h.textContent.replace(/\s+/g,' ').trim(), paras: [], specs: [] };
      out.push(cur);
    } else if(cur && el.tagName==='P'){
      // A section is heading -> paragraph(s) -> bullets. A paragraph after the
      // bullets (the "Live in Park City?" delivery line) belongs to no origin.
      if(cur.specs.length){ cur = null; return }
      const t = el.textContent.replace(/\s+/g,' ').trim(); if(t) cur.paras.push(t);
    } else if(cur && el.tagName==='UL'){
      el.querySelectorAll('li').forEach(li=>{
        const lab = li.querySelector('strong');
        const label = lab ? lab.textContent.replace(/:\s*$/,'').trim() : '';
        const text = li.textContent.replace(lab ? lab.textContent : '','').replace(/\s+/g,' ').trim();
        if(text) cur.specs.push({label, text});
      });
    }
  });
  return out;
}
function originSectionFor(p, country){
  if(!country) return null;
  if(!p._origins) p._origins = parseOriginSections(p.description);
  const c = country.toLowerCase();
  const needles = [c, ...c.split(/\s+/).filter(w=>w.length>3), ...(ORIGIN_ALIASES[country]||[])];
  return p._origins.find(sec => { const h = sec.heading.toLowerCase(); return needles.some(n=>h.includes(n)); }) || null;
}
// Listings without per-country sections (every blend and single-variant coffee)
// still have real copy in Shopify: a hook line, an opening paragraph or two, and
// "Label: value" bullets. Show those instead, minus anything the spec table above
// already covers. The full description stays on the product page.
const HOUSEKEEPING = /^(live in park city|store away from)/i;
const SPEC_ALREADY_SHOWN = /^(roast|origin|best (for|as)|available in)$/i;
function listingSummary(p, hasSections){
  if(p._summary !== undefined) return p._summary;
  if(!p.description){ p._summary = null; return null }
  const doc = new DOMParser().parseFromString(p.description,'text/html');
  const kids = [...doc.body.children];
  const startsWithHeading = kids[0] && /^H[1-4]$/.test(kids[0].tagName);
  let heading = '';
  if(startsWithHeading){
    const h = kids[0].cloneNode(true); h.querySelectorAll('span').forEach(x=>x.remove());
    heading = h.textContent.replace(/\s+/g,' ').trim();
  }
  // Only the opening copy: paragraphs before the first heading, or under the
  // opening heading if the description starts with one.
  const paras = []; let seen = 0;
  for(const el of kids){
    if(/^H[1-6]$/.test(el.tagName)){ seen++; if(seen > (startsWithHeading?1:0)) break; continue }
    if(el.tagName!=='P') continue;
    const t = el.textContent.replace(/\s+/g,' ').trim();
    if(!t || HOUSEKEEPING.test(t)) continue;
    paras.push(t); if(paras.length===2) break;
  }
  // Bullets belong to the whole listing only when there are no per-country
  // sections; otherwise they would be some other origin's tasting notes.
  const specs = [];
  if(!hasSections) doc.querySelectorAll('li').forEach(li=>{
    const t = li.textContent.replace(/\s+/g,' ').trim();
    const m = t.match(/^[^A-Za-z]*([A-Za-z][^:]{1,24}):\s*(.+)$/);
    if(!m || SPEC_ALREADY_SHOWN.test(m[1].trim()) || specs.length>=6) return;
    specs.push({label:m[1].trim(), text:m[2].trim()});
  });
  p._summary = (paras.length || specs.length) ? {heading, paras, specs} : null;
  return p._summary;
}
// A listing has per-country sections only when some heading matches one of its
// first option's values (Nicaragua, Peru, ...). Counting headings is not enough:
// Heli Drop has "The Region" and "Taste Profile" and is one coffee.
function hasOriginSections(p){
  if(p._hasOriginSections === undefined){
    const first = p.options && p.options[0];
    p._hasOriginSections = !!(first && first.name!=='Title' && (first.values||[]).some(v=>originSectionFor(p,v)));
  }
  return p._hasOriginSections;
}
function renderOrigin(p){
  const box = $('#modalOriginNote'); if(!box) return;
  const first = p.options && p.options[0];
  let sec = hasOriginSections(p) ? originSectionFor(p, selection[first.name]) : null;
  if(!sec) sec = listingSummary(p, hasOriginSections(p));
  const fl = sec && sec.specs.find(x=>/flavou?r/i.test(x.label));
  $('#modalFlavors').textContent = fl ? fl.text.split(/,\s*/).join(' · ') : p.flavors;
  if(!sec){ box.hidden = true; box.innerHTML = ''; return }
  box.innerHTML = (sec.heading ? `<h3 class="origin-title">${esc(sec.heading)}</h3>` : '')
    + sec.paras.map(t=>`<p class="origin-body">${esc(t)}</p>`).join('')
    + (sec.specs.length ? `<dl class="origin-specs">${sec.specs.map(x=>`<div><dt>${esc(x.label)}</dt><dd>${esc(x.text)}</dd></div>`).join('')}</dl>` : '');
  box.hidden = false;
}
function renderOptions(p){
  const wrap = $('#modalOptions');
  if(!p.options || !p.options.length || p.singleVariant){ wrap.innerHTML=''; return }
  wrap.innerHTML = p.options.map(o=>`
    <div class="option-group" role="group" aria-label="${esc(o.name)}">
      <span class="option-name">${esc(o.name)}</span>
      <div class="option-values">${o.values.filter(v=>valueCompatible(p,o.name,v,selection)).map(val=>{
        const on = selection[o.name]===val;
        const ok = valueSelectable(p,o.name,val,selection);
        return `<button type="button" class="option-value${on?' is-selected':''}${ok?'':' is-unavailable'}" data-opt="${esc(o.name)}" data-val="${esc(val)}" aria-pressed="${on}">${esc(val)}</button>`;
      }).join('')}</div>
    </div>`).join('');
  $$('.option-value',wrap).forEach(b=>b.addEventListener('click',()=>chooseOption(p,b.dataset.opt,b.dataset.val)));
}
/* Purchase type: one-time vs a Seal Subscriptions selling plan.
   Plans and their prices come from Shopify, so whatever is configured in Seal
   is what the storefront offers — nothing about the schedule is hardcoded here. */
let purchasePlanId = null;   // null = one-time
function allPlans(p){
  return (p.sellingPlanGroups||[]).flatMap(g => (g.plans||[]).map(pl => ({...pl, group:g.name})));
}
function allocationFor(v,planId){
  return ((v && v.allocations) || []).find(a => String(a.planId) === String(planId)) || null;
}
function renderPurchase(p,v){
  const wrap = $('#modalPurchase');
  const plans = allPlans(p).filter(pl => allocationFor(v,pl.id));
  if(!plans.length){ wrap.innerHTML=''; purchasePlanId=null; return }
  if(purchasePlanId && !plans.some(pl=>String(pl.id)===String(purchasePlanId))) purchasePlanId=null;
  // Products flagged requires_selling_plan in Shopify (the 12 Countries subscription)
  // ARE a subscription — they cannot be bought once, so no one-time option is offered.
  const subOnly = !!p.requiresSellingPlan;
  if(subOnly && purchasePlanId === null) purchasePlanId = plans[0].id;
  const row = (id,label,note,price,on) =>
    `<button type="button" class="purchase-option${on?' is-selected':''}" data-plan="${id===null?'':esc(id)}" aria-pressed="${on}">
       <span class="purchase-label">${esc(label)}</span>
       <span class="purchase-price">${price}</span>
       ${note?`<span class="purchase-note">${esc(note)}</span>`:''}
     </button>`;
  wrap.innerHTML = `<span class="option-name">${subOnly ? 'Subscription' : 'Purchase'}</span><div class="purchase-options">`
    + (subOnly ? '' : row(null,'One time', '', v ? money(v.price) : '', purchasePlanId===null))
    + plans.map(pl=>{
        const a = allocationFor(v,pl.id);
        return row(pl.id, pl.name, 'Ships the 1st · cancel anytime', money(a.price)+'/mo', String(purchasePlanId)===String(pl.id));
      }).join('')
    + `</div>`;
  $$('.purchase-option',wrap).forEach(b=>b.addEventListener('click',()=>{
    purchasePlanId = b.dataset.plan || null;
    syncVariant(p);
  }));
}
function syncVariant(p){
  const v = p.singleVariant ? (p.variants||[])[0] : matchVariant(p,selection);
  const add = $('#modalAdd');
  add.dataset.variant = v ? v.id : '';
  renderPurchase(p,v);
  add.dataset.plan = purchasePlanId || '';
  if(v){
    const alloc = purchasePlanId ? allocationFor(v,purchasePlanId) : null;
    $('#modalPrice').textContent = alloc ? `${money(alloc.price)} / month` : money(v.price);
    // A requires_selling_plan product can never be added without a plan.
    const planMissing = p.requiresSellingPlan && !purchasePlanId;
    add.disabled = !v.available || planMissing;
    add.textContent = !v.available ? 'Sold out'
                    : planMissing ? 'Choose a plan'
                    : (purchasePlanId ? 'Subscribe' : 'Add to bag');
  } else {
    $('#modalPrice').textContent = `From ${money(p.price)}`;
    add.disabled = true;
    add.textContent = 'Unavailable';
  }
}
function starsMarkup(rating,count,url){
  if(!rating) return '';
  const r = parseFloat(rating);
  if(!r) return '';
  const pct = Math.max(0,Math.min(100,(r/5)*100));
  // The full Judge.me widget lives on the product page, so the quick view shows the
  // summary and links through rather than shipping every review to the homepage.
  const stars = `<span class="stars" style="--pct:${pct.toFixed(1)}%" aria-hidden="true">★★★★★</span>`
              + `<span class="rating-text" aria-hidden="true">${r.toFixed(2)} <span class="rating-count">(${count})</span></span>`
              + `<span class="visually-hidden">Rated ${r.toFixed(2)} out of 5 from ${count} reviews</span>`;
  if(!url) return `<p class="rating-line">${stars}</p>`;
  return `<p class="rating-line"><a class="rating-jump" href="${url}#reviews">${stars}`
       + `<span class="rating-more">Read ${count} review${count==1?'':'s'} &rarr;</span></a></p>`;
}

$$('.product-card').forEach(card=>card.addEventListener('click',e=>{
  // Cards are real <a href> links so they crawl and middle-click works.
  // Only intercept an unmodified left click to open the quick view.
  if(e.target.closest('.product-add')) return;
  if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button!==0) return;
  e.preventDefault();
  openProduct(card.dataset.product);
}));
// Card Add to bag. Liquid decides per coffee (snippets/concept-quick-add): "add" puts the
// default variant (and the subscription's plan) straight in the bag; "open" means the coffee
// needs a choice first, so the quick view opens instead.
$$('.product-add').forEach(btn=>btn.addEventListener('click',async e=>{
  e.preventDefault();
  const slug = btn.closest('.product-card').dataset.product;
  if(btn.dataset.mode!=='add' || !btn.dataset.variant){ openProduct(slug); return }
  const label = btn.textContent;
  btn.disabled = true; btn.textContent = 'Adding';
  const ok = await addVariant(Number(btn.dataset.variant), btn.dataset.plan || null, btn.dataset.toast);
  btn.disabled = false;
  if(!ok){ btn.textContent = label; return }
  btn.classList.add('is-added'); btn.textContent = 'Added';
  setTimeout(()=>{ btn.classList.remove('is-added'); btn.textContent = label }, 1600);
}));
function openProduct(slug){
  const p=productMap[slug]; if(!p) return;
  activeProduct = p;
  $('#modalImage').src=p.image; $('#modalImage').alt=p.name+' coffee';
  $('#modalImage').closest('.modal-media').classList.toggle('is-photo', !!p.photo);
  $('#modalEyebrow').textContent=`${p.id} / ${p.roast} roast`;
  $('#modalName').textContent=p.name; $('#modalFlavors').textContent=p.flavors;
  $('#modalRating').innerHTML=starsMarkup(p.rating,p.ratingCount,p.url);
  $('#modalRoast').textContent=p.roast; $('#modalOrigin').textContent=p.origin;
  $('#modalBrew').textContent=p.brew;
  purchasePlanId = null;
  defaultSelection(p); renderOptions(p); renderOrigin(p); syncVariant(p);
  openOverlay(modal);
}
$('#modalAdd').addEventListener('click',async e=>{
  const id = e.currentTarget.dataset.variant;
  if(!id) return;
  await addVariant(Number(id), e.currentTarget.dataset.plan || null);
  closeOverlays();
});

$('#bagButton').addEventListener('click',()=>openOverlay(cartPanel));
async function addVariant(variantId, sellingPlanId, label){
  if(!variantId){ showToast('Unavailable'); return false }
  const item = {id:variantId, quantity:1};
  if(sellingPlanId) item.selling_plan = Number(sellingPlanId);
  let res;
  try{
    res = await fetch(ROUTES.cartAdd,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[item]})});
  }catch(err){ showToast('Could not add to bag'); return false }
  if(!res.ok){ showToast('Could not add to bag'); return false }
  await refreshCart();
  const p = variantMap[variantId];
  showToast(`${label || (p ? p.name : 'Item')} ${sellingPlanId ? 'subscription added' : 'added to bag'}`);
  return true;
}
async function refreshCart(){
  try{ cart = await (await fetch(ROUTES.cart)).json() }catch(e){ return }
  renderCart();
}
function renderCart(){
  $('#bagCount').textContent=cart.item_count;
  const items=$('#cartItems');
  if(!cart.items.length){items.innerHTML='<p class="cart-empty">Your bag is empty.</p>';}
  else items.innerHTML=cart.items.map(i=>{
    const c=variantMap[i.variant_id];
    const name=c?c.name:i.product_title;
    const image=c?c.image:(i.image||'');
    const variantLabel = i.variant_title && i.variant_title !== 'Default Title' ? ` · ${esc(i.variant_title)}` : '';
    const plan = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan;
    const planLabel = plan ? `<span class="cart-plan">${esc(plan.name)}</span>` : '';
    return `<article class="cart-item">
      <div class="cart-thumb"><img src="${esc(image)}" alt=""></div>
      <div>
        <h4>${esc(name)}</h4>
        <p>${money(i.price/100)}${variantLabel}</p>
        ${planLabel}
        <div class="qty">
          <button type="button" data-step="-1" data-key="${esc(i.key)}" aria-label="Decrease quantity of ${esc(name)}">−</button>
          <span aria-label="Quantity">${i.quantity}</span>
          <button type="button" data-step="1" data-key="${esc(i.key)}" aria-label="Increase quantity of ${esc(name)}">+</button>
        </div>
      </div>
      <div>
        <span class="cart-line-total">${money(i.line_price/100)}</span>
        <button class="icon-button" data-remove="${esc(i.key)}" aria-label="Remove ${esc(name)}">×</button>
      </div>
    </article>`;
  }).join('');
  $('#cartTotal').textContent=money(cart.total_price/100);
  $$('[data-remove]',items).forEach(b=>b.addEventListener('click',()=>changeLine(b.dataset.remove,0)));
  $$('[data-step]',items).forEach(b=>b.addEventListener('click',()=>{
    const line = cart.items.find(x=>x.key===b.dataset.key);
    if(!line) return;
    changeLine(b.dataset.key, Math.max(0, line.quantity + Number(b.dataset.step)));
  }));
}
async function changeLine(key,quantity){
  try{
    await fetch(ROUTES.cartChange,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity})});
  }catch(e){ showToast('Could not update bag'); return }
  await refreshCart();
}
let toastTimer;
function showToast(text){const t=$('#toast');t.textContent=text;t.classList.add('show');clearTimeout(toastTimer);toastTimer=setTimeout(()=>t.classList.remove('show'),2200)}
refreshCart();

/* Autoplaying video is opt-out for anyone who asks for reduced motion.
   The poster frame remains, so the section still reads as intended. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const apply = () => $$('video[autoplay]').forEach(v => {
    if(reduce.matches){ v.removeAttribute('autoplay'); v.pause(); v.currentTime = 0; }
    else { v.play().catch(()=>{}); }
  });
  apply();
  reduce.addEventListener('change', apply);
})();
